import EditTradeAccountPartnerCode from './EditTradeAccountPartnerCode';

export default EditTradeAccountPartnerCode;
